<template>
  <div
    class="game-tr-input"
    :class="[{ 'position-inherit': elementTopPosition ? false : true }]"
    :style="setInputGameStyle()"
  >
    <input
      v-model="inputVal"
      type="text"
      placeholder=""
      class="inline-input tr-input-text"
      :class="[
        { 'inline-input-disabled': getInputData().block === true },
        { 'inline-input-correct': getInputData().inputStatus === 'correct' },
        { 'inline-input-wrong': getInputData().inputStatus === 'incorrect' },
        { 'inline-input-text-aling-center': elementTextAlign === 'center' },
        { 'inline-input-text-aling-left': elementTextAlign === 'left' },
        { 'inline-input-text-aling-right': elementTextAlign === 'right' },
      ]"
      :style="'font-size:' + inputFontSize + ';' + 'background:' + backgroundColor + ';'"
      :maxlength="maxLength"
      :disabled="getInputData().block === true"
      @click="resetCheckStatus"
      @keyup.left="keyArrowLeft"
      @keyup.right="keyArrowRight"
      @keyup.up="keyArrowUp"
      @keyup.down="keyArrowDown"
      @input="signalChange"
    />
  </div>
</template>

<script>
import _ from 'lodash';
import * as utils from '../../Utils/inputUtilsV2';
export default {
  name: 'tr-input-v2',
  components: {},
  props: {
    config: {
      type: null,
      default: function () {
        return {};
      },
    },
    trInputValue: {
      type: null,
      default: '',
    },
    trInputValueIndex: {
      type: null,
      default: 0,
    },
    offsetHorizontal: {
      type: Number,
      default: 0,
    },
    offsetVertical: {
      type: Number,
      default: 0,
    },
    inputWidth: {
      type: null,
      default: 'auto',
    },
    inputHeight: {
      type: null,
      default: 'auto',
    },
    inputType: {
      type: String,
      default: 'normal',
    },
    inputFontStyle: {
      type: String,
      default: 'normal',
    },
    maxLength: {
      type: null,
      default: 255,
    },
    backgroundColor: {
      type: String,
      default: 'transparent',
    },
    inputFontSize: {
      type: null,
      default: 44,
    },
  },
  data() {
    return {
      text: '',
    };
  },
  created() {},
  mounted() {},
  methods: {
    signalChange: function ($event) {
      if (!_.isEmpty($event.target.value)) {
        this.$emit('changeElement', $event, this.config.id);
      }
    },
    keyArrowLeft($event) {
      this.$emit('keyArrowLeft', $event, this.config.id);
    },
    keyArrowRight($event) {
      this.$emit('keyArrowRight', $event, this.config.id);
    },
    keyArrowUp($event) {
      this.$emit('keyArrowUp', $event, this.config.id);
    },
    keyArrowDown($event) {
      this.$emit('keyArrowDown', $event, this.config.id);
    },
    resetCheckStatus() {
      this.$store.dispatch('resetCheckStatus');
      /** @type {Boolean}  return true becouse want to event to propagate  */
      return true;
    },
    getInputData() {
      if (_.isArray(this.trInputValue) && _.isObject(this.trInputValue[this.trInputValueIndex])) {
        return this.trInputValue[this.trInputValueIndex];
      } else {
        return this.trInputValue;
      }
    },
    setInputGameStyle() {
      return `top:${this.elementTopPosition};
              left:${this.elementLeftPosition};
              width:${this.elementWidth};
              height:${this.elementHeight};
              border-radius:${this.borderRadius};`;
    },
  },
  computed: {
    inputVal: {
      get() {
        if (_.isArray(this.trInputValue) && _.isObject(this.trInputValue[this.trInputValueIndex])) {
          return this.trInputValue[this.trInputValueIndex].val;
        }
        return this.trInputValue.val;
      },
      set(newValue) {
        if (_.isArray(this.trInputValue) && _.isObject(this.trInputValue[this.trInputValueIndex])) {
          if (!this.trInputValue[this.trInputValueIndex].block) {
            this.trInputValue[this.trInputValueIndex].val = newValue;
          }
        } else {
          if (!this.trInputValue.block) {
            this.trInputValue.val = newValue;
          }
        }
        // this.$emit('changeElement',$event);
      },
    },
    elementTopPosition() {
      return this.config && this.config.pos
        ? utils.elementTopPosition(this.config.pos.y || 0, this.offsetVertical)
        : undefined;
    },
    elementLeftPosition() {
      return this.config && this.config.pos
        ? utils.elementLeftPosition(this.config.pos.x || 0, this.offsetHorizontal)
        : undefined;
    },
    elementWidth() {
      return utils.elementWidth(this.inputWidth);
    },
    elementHeight() {
      return utils.elementHeight(this.inputHeight);
    },
    elementTextAlign() {
      let align = 'center';
      if (this.config && this.config.align) {
        align = this.config.align;
      }
      return align;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/variable';
@import '~@/assets/sass/iconColor';
@import '~@/assets/sass/inputBase';
.game-tr-input {
  display: flex;
  position: absolute;
  justify-content: center;
  align-items: center;
  background-color: $bacgroundColor;
}

.position-inherit {
  position: inherit;
}
</style>
